import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import s from './CaptionCell.module.scss';

export const CaptionCell = ({ children }) => (
  <TableCell className={s.CaptionCell}>{children}</TableCell>
);
